import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  const { modalityId } = action;
  try {
    yield put({ type: Types.GET_CAMPUS_BY_MODALITY_REQUEST });
    XCheckpointManager.registerStart(
      'Emisión de carné universitario modalidad'
    );
    // leer perfil
    const procedureRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureResponse = yield call(
      procedureRepository.getCampusByModality,
      modalityId
    );
    if (!procedureResponse) {
      yield put({
        type: Types.GET_CAMPUS_BY_MODALITY_FAILURE,
        error: 'No se pudo leer los datos del estudiante.'
      });
      return;
    }
    yield put({
      type: Types.GET_CAMPUS_BY_MODALITY_SUCCESS,
      data: procedureResponse
    });
    XCheckpointManager.registerEnd('Emisión de carné universitario modalidad');
  } catch (error) {
    yield put({
      type: Types.GET_CAMPUS_BY_MODALITY_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del estudiante.'
    });
  }
}
